var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoSeries = function SvgIcoSeries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#fff",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.18 2a1 1 0 0 0-.986 1.164l.14.836h17.333l.139-.836A1 1 0 0 0 19.82 2zm-.986 5.164A1 1 0 0 1 4.18 6h15.64a1 1 0 0 1 .986 1.164l-.14.836H3.334zM4.18 10a1 1 0 0 0-.986 1.164l1.597 9.583A1.5 1.5 0 0 0 6.271 22h11.458a1.5 1.5 0 0 0 1.48-1.253l1.597-9.583A1 1 0 0 0 19.82 10zm9.942 6.855a1 1 0 0 0 .001-1.701l-2.597-1.607a1 1 0 0 0-1.526.85v3.209a1 1 0 0 0 1.525.851z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoSeries;